import { db } from '@util/firebase';
import {
  collection,
  CollectionReference,
  getDocs,
  limit,
  query,
  where,
} from 'firebase/firestore';
import { UserDocument } from '@util/types/firestore/users';

const userRef = collection(db, 'users') as CollectionReference<UserDocument>;

export async function getUserByUsername(
  username: string,
): Promise<UserDocument | null> {
  if (!username) return null;

  const q = query(userRef, where('username', '==', username), limit(1));
  const docSnap = await getDocs(q);
  return docSnap.size ? docSnap.docs[0].data() : null;
}

export async function getUserByUsernameSlug(
  username_slug: string,
): Promise<UserDocument | null> {
  if (!username_slug) return null;

  const q = query(userRef, where('username_slug', '==', username_slug), limit(1));
  const docSnap = await getDocs(q);
  return docSnap.size ? docSnap.docs[0].data() : null;
}
